
@if (plansFullData && plans) {
  <section class="mat-typography mat-app-background mat-body component-wrapper-print">
    <!-- Headers -->
    <div>
      @if (plansFullData?.length === 1) {
        <app-plan-details-header
          [viewPlansUrl]="viewPlansUrl"
          [recommendedPlansUrl]="recommendedPlansUrl"
          [sendReferralUrl]="sendReferralUrl"
          [enrollStartUrl]="enrollStartUrl"
          [specialEnrollmentUrl]="specialEnrollmentUrl"
          [planData]="plansFullData[0]"
          [showSaveQuoteButton]="showSaveQuoteButton"
          [enableNewPrintExperience]="enableNewPrintExperience"
          [saveQuoteText]="saveQuoteText"
          [returnUrl]="returnUrl"
          [enrollmentFlow]="enrollmentFlow"
          [quoteButtonPage]="quoteButtonPage">
        </app-plan-details-header>
      }
      @if (plansFullData?.length > 1) {
        <app-compare-plans-header
          [viewPlansUrl]="viewPlansUrl"
          [recommendedPlansUrl]="recommendedPlansUrl"
          [enrollStartUrl]="enrollStartUrl"
          [specialEnrollmentUrl]="specialEnrollmentUrl"
          [iconographyDetails]="iconographyDetails"
          [plans]="plansFullData"
          [showSaveQuoteButton]="showSaveQuoteButton"
          [saveQuoteText]="saveQuoteText"
          [returnUrl]="returnUrl"
          [enableNewPrintExperience]="enableNewPrintExperience"
          [enrollmentFlow]="enrollmentFlow"
          [quoteButtonPage]="quoteButtonPage">
        </app-compare-plans-header>
        @if (enableHighlightBenefitDifferences === 'true') {
          <app-compare-plans-highlight></app-compare-plans-highlight>
        }
      }
    </div>
    <!-- TAB GROUPS -->
    @if (showTabs) {
      <mat-tab-group
        (selectedTabChange)="changeTabs($event)"
        class="margin-top" color="primary"
        animationDuration="0ms" mat-align-tabs="center">
        <!-- PLAN DETAILS -->
        <mat-tab [label]='DETAILS_TAB'>
          <ng-template mat-tab-label>
            <h2>{{planDetailsTabLabel || 'Plan Details'}}</h2>
          </ng-template>
          @if (showDoctorDetails === 'true') {
            <app-doctor-detail
              [plan]="plansFullData[0]"
            ></app-doctor-detail>
          }
          <app-plan-details
            [enrollStartUrl]="enrollStartUrl"
            [whbStartUrl]="wholeHealthBalanceEnrollStartUrl"
            [viewPlansUrl]="viewPlansUrl"
            [recommendedPlansUrl]="recommendedPlansUrl"
            [plansFullData]="plansFullData"
            [plans]="plans"
            [market]="market"
            [enrollmentFlow]="enrollmentFlow">
          </app-plan-details>
        </mat-tab>
        <!-- DRUG COSTS -->
        @if (enableDrx) {
          <mat-tab [label]='DRX_TAB'>
            <ng-template mat-tab-label>
              <h2>{{totalDrugCostsTabLabel || 'Total Drug Costs'}}</h2>
            </ng-template>
            <!-- Force refresh on nav-away -->
            <ng-template matTabContent>
              @if (!isLoadingDrx) {
                <div class="edit-meds-content">
                  <a href="javascript:void(0)" (click)="goToUrl(addMedicationsUrl)">
                    {{addMedicationRedirectLabel || 'Add or Edit Medications'}}
                  </a>
                </div>
                @if (hasDrx) {
                  <app-toggle-radio></app-toggle-radio>
                  <app-pharmacy-detail></app-pharmacy-detail>
                  @if (!isLoadingPharmacy) {
                    <app-total-drug-cost
                      [coverageHeading]="coveragePhaseHeading"
                      [monthlyHeading]="monthlyTableHeading"
                      [monthlyCostDescriptionContent]="monthlyCostDescriptionContent">
                    </app-total-drug-cost>
                  }
                  @if (isLoadingPharmacy) {
                    <div class='loading'>
                      <mat-spinner [diameter]="80"></mat-spinner>
                    </div>
                  }
                } @else {
                  <h3 class="text-center">You don't have any drugs selected. Click the link to add them.</h3>
                }
              }
              @if (isLoadingDrx) {
                <div class='loading'>
                  <mat-spinner [diameter]="80"></mat-spinner>
                </div>
              }
            </ng-template>
          </mat-tab>
        }
        <!-- ANNUAL COSTS -->
        @if (enableDrx) {
          <mat-tab [label]='DRX_TAB'>
            <ng-template mat-tab-label>
              <h2>{{totalCostsTabLabel || 'Total Costs'}}</h2>
            </ng-template>
            <!-- Force refresh on nav-away -->
            <ng-template matTabContent>
              @if (!isLoadingDrx) {
                <div class="edit-meds-content">
                  <a href="javascript:void(0)" (click)="goToUrl(addMedicationsUrl)">
                    {{addMedicationRedirectLabel || 'Add or Edit Medications'}}
                  </a>
                </div>
                @if (hasDrx) {
                  <app-toggle-radio></app-toggle-radio>
                  <app-pharmacy-detail></app-pharmacy-detail>
                  @if (!isLoadingPharmacy) {
                    <app-yearly-drug-costs-graph
                      [sectionHeading]="yearlyDrugCostsHeading"
                      [yearlyCostDescriptionContent]="yearlyCostDescriptionContent">
                    </app-yearly-drug-costs-graph>
                    <app-yearly-drug-costs-table></app-yearly-drug-costs-table>
                  }
                  @if (isLoadingPharmacy) {
                    <div class='loading'>
                      <mat-spinner [diameter]="80"></mat-spinner>
                    </div>
                  }
                } @else {
                  <h3 class="text-center">You don't have any drugs selected. Click the link to add them.</h3>
                }
              }
              @if (isLoadingDrx) {
                <div class='loading'>
                  <mat-spinner [diameter]="80"></mat-spinner>
                </div>
              }
            </ng-template>
          </mat-tab>
        }
        <!-- PREMIUM DETAILS - Individual Markets ONLY -->
        @if (hasPremiumDetails) {
          <mat-tab [label]='PREMIUM_TAB'>
            <ng-template mat-tab-label>
              <h2>{{familyPremiumDetails || 'Family Premium Details'}}</h2>
            </ng-template>
            <app-premium-details-individual></app-premium-details-individual>
          </mat-tab>
        }
        <!-- Plan Documents tab -->
        @if (hasPlanDocs) {
          <mat-tab [label]='DOCUMENTS_TAB'>
            <ng-template mat-tab-label>
              <h2>Plan Documents</h2>
            </ng-template>
            <app-plan-details-documents [tabChange]="tabChangeSubject.asObservable()"></app-plan-details-documents>
          </mat-tab>
        }
      </mat-tab-group>
    } @else {
      <app-plan-details class="margin-top"
        [plansFullData]="plansFullData"
        [fullPlansData]="fullPlansData"
        [plans]="plans"
        [enrollStartUrl]="enrollStartUrl"
        [whbStartUrl]="wholeHealthBalanceEnrollStartUrl"
        [viewPlansUrl]="viewPlansUrl"
        [recommendedPlansUrl]="recommendedPlansUrl"
        [market]="market"
        [enrollmentFlow] = "enrollmentFlow">
      </app-plan-details>
    }
    <!-- NO TAB GROUPS -->
  </section>
}

@if (!plansFullData || !plans) {
  <section class="mat-typography mat-app-background mat-body component-wrapper-print">
    <div class='loading'>
      <mat-spinner [diameter]="80"></mat-spinner>
    </div>
  </section>
}